var $ad9be5d332b4d607$exports = {};
$ad9be5d332b4d607$exports = {
    "breadcrumbs": `\u{D0D0}\u{C0C9} \u{D45C}\u{C2DC}`
};


export {$ad9be5d332b4d607$exports as default};
//# sourceMappingURL=ko-KR.module.js.map
